import * as React from "react";
import { SkeletonCard } from "./SkeletonCard";

const SKELETON_COUNT = 12;

export const SkeletonGrid: React.FC = () => {
  const skeletons = Array.from({ length: SKELETON_COUNT }, (_, index) => <SkeletonCard key={`skeleton-${index}`} />);

  return <div className="skeleton-grid">{skeletons}</div>;
};
